// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveReadyPlanOptionGroupsMutationVariables = Types.Exact<{
  inputs: Array<Types.SaveReadyPlanOptionGroupInput> | Types.SaveReadyPlanOptionGroupInput;
}>;


export type SaveReadyPlanOptionGroupsMutation = { __typename?: 'Mutation', saveReadyPlanOptionGroups: { __typename?: 'SaveReadyPlanOptionGroupsResult', entities: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, isMultiOptionGroup: boolean, isSingleOptionGroup: boolean, required: boolean, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, name: string } }> } };


export const SaveReadyPlanOptionGroupsDocument = gql`
    mutation SaveReadyPlanOptionGroups($inputs: [SaveReadyPlanOptionGroupInput!]!) {
  saveReadyPlanOptionGroups(inputs: $inputs) {
    entities {
      id
      isMultiOptionGroup
      isSingleOptionGroup
      required
      order
      group {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSaveReadyPlanOptionGroupsMutation__
 *
 * To run a mutation, you first call `useSaveReadyPlanOptionGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveReadyPlanOptionGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveReadyPlanOptionGroupsMutation, { data, loading, error }] = useSaveReadyPlanOptionGroupsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSaveReadyPlanOptionGroupsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveReadyPlanOptionGroupsMutation, SaveReadyPlanOptionGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveReadyPlanOptionGroupsMutation, SaveReadyPlanOptionGroupsMutationVariables>(SaveReadyPlanOptionGroupsDocument, options);
      }
export type SaveReadyPlanOptionGroupsMutationHookResult = ReturnType<typeof useSaveReadyPlanOptionGroupsMutation>;
export type SaveReadyPlanOptionGroupsMutationResult = ApolloReactCommon.MutationResult<SaveReadyPlanOptionGroupsMutation>;